import { State } from 'b2b-apps/shop/common/redux/types';

const getSkusFromQuery = (state: State, queryId: string): string[] => {
  const searchResultForQuery = state.catalog.skuList[queryId] || {};

  return searchResultForQuery.data?.skuList
    ? searchResultForQuery.data.skuList
    : [];
};

export { getSkusFromQuery };
